// © Microsoft Corporation. All rights reserved.
export function isSwiftKey() {
    const url = new URL(location.href);
    const platformFlag = url.searchParams.get("chpltfm") || "";
    const ocid = url.searchParams.get("ocid") || "";
    // possible chpltfm values: outlook-ios, outlook-android, office-ios, union-ios, office-android, skype, skype-web
    const hostAppName = platformFlag.toLowerCase().split("-")[0];
    return ocid.toLowerCase() === "swiftKey".toLowerCase() || hostAppName.toLowerCase() == "swiftkey";
}
//# sourceMappingURL=NativeAppCheck.js.map